module.exports = __webpack_public_path__ + "static/img/top-bg.a86d957.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/open-platform/top-bg.png
// module id = 5FFH
// module chunks = 1